import { GetInferredFromRaw } from '@thinknimble/tn-models'
import { z } from 'zod'

export const notificationPreferenceShape = {
  id: z.string().uuid(),
  eventType: z.string(),
  eventLabel: z.string(),
  category: z.string(),
  inApp: z.boolean(),
  email: z.boolean(),
  whatsapp: z.boolean(),
}

export type NotificationPreference = GetInferredFromRaw<typeof notificationPreferenceShape>
